/* global Raven */

export const setUserContext = (ctx) => {
  if (window.Raven) {
    window.Raven.setUserContext(ctx)
  }
}


export const logRavenError = (message, ...data) => {
  if (window.Raven) {
    window.Raven.captureMessage(message, {
      level: 'error',
      extra: {context_data: data},
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/raven.js